import { render, staticRenderFns } from "./FeatureCardDataRowInput.vue?vue&type=template&id=ba52120a&scoped=true&"
import script from "./FeatureCardDataRowInput.vue?vue&type=script&lang=js&"
export * from "./FeatureCardDataRowInput.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCardDataRowInput.vue?vue&type=style&index=0&id=ba52120a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba52120a",
  null
  
)

export default component.exports